import { mergeWith, isNumber } from "lodash"

export const MARGINAL_NON_AGGREGABLE_KEYS = [
  "marginalContribution",
  "correlation",
  "volatility",
]

export function sumNestedContributors(contributor1, contributor2) {
  return mergeWith({}, contributor1, contributor2, (value1, value2, key) => {
    if (MARGINAL_NON_AGGREGABLE_KEYS.includes(key)) {
      return null
    }
    if (isNumber(value1) && isNumber(value2)) {
      return value1 + value2
    }
    return undefined
  })
}
